import * as React from 'react'
import * as ReactDOM from 'react-dom'
import {SettingsFormContainer, createStoreFromParams} from "./app"
import {CallJs} from "../../../lib/types"

export type Params = {
	settings: Settings
	ajaxUrl: string
	publicUrl: string
}

export type Settings = {
	id: number
	instance: string|null
	username: string
	password: string
}

export const settingsForm:CallJs<Params> = (replace, params) => {
	const store = createStoreFromParams(params)
	const div = document.createElement('div')
	replace(div)
	ReactDOM.render(<SettingsFormContainer ajaxUrl={params.ajaxUrl} store={store} />, div)
}



// WEBPACK FOOTER //
// ./src/3rd party integration/wentworthadvantage/settings-form/settings-form.tsx